"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigationQuery = void 0;
var _fetching = require("@ori/fetching");
const navigationItem = (0, _fetching.gql)`
  fragment NavigationItem on Navigation {
    id
    linkType
    type
    title
    link {
      relativeUrl
    }
    imageUrl
    description
  }
`;
const navigationQuery = exports.navigationQuery = (0, _fetching.gql)`
  query Navigation($navigationType: NavigationType!, $customerTypeId: Int, $visitorSegment: VisitorSegment) {
    application {
      navigation(navigationType: $navigationType, customerTypeId: $customerTypeId, visitorSegment: $visitorSegment) {
        children {
          ...NavigationItem
          children {
            ...NavigationItem
            children {
              ...NavigationItem
            }
          }
        }
      }
    }
  }
  ${navigationItem}
`;
